$ = require 'jquery'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class ChangeBoardPermsView extends View
  viewTitleKey: 'change permissions'

  initialize: ->
    @listenTo @model, 'change', @frameDebounce @render
    return

  events:
    'click .js-select': 'selectPerm'

  render: ->
    data = @model.toJSON({ prefs: true, url: true })

    data.cardCovers = data.prefs.cardCovers
    organization = @model.getOrganization()
    data.hasOrg = organization?.id?
    data.orgCanSee = data.hasOrg && @model.getPref('permissionLevel') in ['public', 'org']
    data.premium = organization?.isFeatureEnabled('observers')
    data.voting_showObservers = (data.premium || data.voting_observers) && data.hasOrg
    data.comments_showObservers = (data.premium || data.comments_observers) && data.hasOrg
    data.pLevelClass = BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)

    if organization?.owned()
      data.orgOwner = true
      data.orgName = organization.get('displayName')
      if !@model.owned()
        data.setOrgNull = true
    else if !@model.owned()
      data.noEditOrg = true

    template = @getTemplate()

    @$el.html(
      templates.fillMenu(
        template,
        data,
        { editable: @model.editable(), owned: @model.owned() }
      )
    )

    @

  selectPerm: (e) ->
    Util.stop(e)
    track("Board", "Change #{@getPerm()}")

    $target = $(e.target).closest('.js-select')

    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    perm = @getPerm()
    setting = $target.attr('name')

    @model.setPref(perm, setting)
    @model.save()

    PopOver.popView()

    return
